import {
    AMOUNT_BORROWED_SET_VALUE,
    AMOUNT_BORROWED_SET_VALID,
    CUSTOM_AMOUNT_BORROWED_SET_VALUE,
    CUSTOM_AMOUNT_BORROWED_SET_VALID,
    REPAYMENT_DURATION_SET_VALUE,
    REPAYMENT_DURATION_SET_VALID,
    CUSTOM_REPAYMENT_DURATION_SET_VALUE,
    CUSTOM_REPAYMENT_DURATION_SET_VALID,
    CALCULATE_LOAN_RESULTS,
    CALCULATE_LOAN_RESULTS_SUCCESS,
    CALCULATE_LOAN_RESULTS_FAILURE,
    RESET_FORM,
} from '../../actions/namPersonalLoansCalculator/calculator';
import { API_CALL_STATUS, FORM_STATUS, FIELD_STATUS } from '../status';

const initial = {
    formStatus: FORM_STATUS.INVALID,
    form: {
        amountBorrowed: { value: null, error: null, status: null },
        customAmountBorrowed: { value: null, error: null, status: null },
        repaymentDuration: { value: null, error: null, status: null },
        customRepaymentDuration: { value: null, error: null, status: null },
    },
    calculationResults: {
        status: API_CALL_STATUS.IDLE,
        error: null,
        results: null,
    },
};

export default (state = initial, action) => {
    const mapError = (error) => (error ? FIELD_STATUS.ERROR : FIELD_STATUS.VALID);
    const updateFormField = (fieldId, update) => ({
        ...state,
        form: {
            ...state.form,
            [fieldId]: update(state.form[fieldId]),
        },
    });

    switch (action.type) {
        case CALCULATE_LOAN_RESULTS:
            return {
                ...state,
                calculationResults: {
                    ...state.calculationResults,
                    status: API_CALL_STATUS.PENDING,
                },
            };
        case CALCULATE_LOAN_RESULTS_SUCCESS:
            return {
                ...state,
                calculationResults: {
                    ...state.calculationResults,
                    status: API_CALL_STATUS.SUCCESS,
                    results: action.value,
                },
            };
        case CALCULATE_LOAN_RESULTS_FAILURE:
            return {
                ...state,
                calculationResults: {
                    ...state.calculationResults,
                    status: API_CALL_STATUS.FAILURE,
                    error: action.error,
                },
            };
        case RESET_FORM:
            return initial;
        case AMOUNT_BORROWED_SET_VALUE:
            return updateFormField('amountBorrowed', (field) => ({
                ...field,
                value: action.value,
            }));
        case AMOUNT_BORROWED_SET_VALID:
            return updateFormField('amountBorrowed', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));
        case CUSTOM_AMOUNT_BORROWED_SET_VALUE:
            return updateFormField('customAmountBorrowed', (field) => ({
                ...field,
                value: action.value,
            }));
        case CUSTOM_AMOUNT_BORROWED_SET_VALID:
            return updateFormField('customAmountBorrowed', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));
        case REPAYMENT_DURATION_SET_VALUE:
            return updateFormField('repaymentDuration', (field) => ({
                ...field,
                value: action.value,
            }));
        case REPAYMENT_DURATION_SET_VALID:
            return updateFormField('repaymentDuration', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));
        case CUSTOM_REPAYMENT_DURATION_SET_VALUE:
            return updateFormField('customRepaymentDuration', (field) => ({
                ...field,
                value: action.value,
            }));
        case CUSTOM_REPAYMENT_DURATION_SET_VALID:
            return updateFormField('customRepaymentDuration', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));
        default:
            return state;
    }
};
